import React, { useState } from 'react';
import {
  ApiButton,
  Button,
  ContentTemplate,
  TextFieldForm,
  ErrorInfo,
  Grid,
  nameRegExp,
  SectionHeader,
  yesterdayDate,
} from 'web-library';
import { useTranslation } from 'react-i18next';
import  dayjs, {Dayjs} from 'dayjs';

import { makeStyles } from 'tss-react/mui';
import { useHistory } from 'react-router-dom';
import { BlacklistingExamType } from './ExamTypeSingleSelect';
import ControlledCustomSelect from '../../../../components/form-items/ControlledCustomSelect';
import { ID_TYPE_MENU_ITEMS } from '../../../profile/components/CandidateProfileForm/CandidateProfilePersonalParticulars';
import { useAddCandidateBlacklist } from '../../logic/useAddCandidateBlacklist';
import RouteKey from '../../../../routes/key';
import ControlledAutocomplete from '../../../../components/form-items/ControlledAutocomplete';
import { DropDownItem } from '../../../../hooks/dropdown';
import ControlledDatePicker from "web-library/stories/atom/DatePicker/ControlledDatePicker";

const useStyles = makeStyles()((theme) =>
({
  formElementContainer: {
    marginBottom: theme.spacing(4),
  },
  halfWidthLeftItem: {
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(4),
    },
  },
  halfWidthRightItem: {
    width: '50%',
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingLeft: 0,
    },
  },
  actionButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginRight: 0,
      marginBottom: theme.spacing(2),
    },
  },
  errMsg: {
    paddingBottom: theme.spacing(2),
  },
}));

const { candidateBlacklist } = RouteKey.admin.child;
const { admin } = RouteKey.child;

const AddCandidateBlacklist = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { form, addCandidateToBlacklist, apiMutation, submitError } = useAddCandidateBlacklist();
  const { register, formState: { errors }, control, handleSubmit, setValue } = form;
  const [dateOfBirth, setDateOfBirth] = useState<string>('');
  const history = useHistory();

  return (
    <ContentTemplate>
      <SectionHeader title={t('admin->>CandidateBlacklist.CandidateDetails')} />
      <form onSubmit={handleSubmit((formData) => addCandidateToBlacklist(formData))}>
        <TextFieldForm
            form={form}
          isInputTextUpperCase
          onChange={(e) => setValue('name', e.target.value.toUpperCase())}
          label={t('admin->>CandidateBlacklist.Name')}
          name="name"
          placeholder={t('admin->>CandidateBlacklist.EnterName')}
          type="text"
          error={!!errors.name}
          helperText={errors?.name?.message?.toString()}
          className={classes.formElementContainer}
          fullWidth
          isRequired
          regExpToBlock={nameRegExp}
        />
        <Grid container className={classes.formElementContainer}>
          <Grid xs={12} sm={6}>
            <ControlledCustomSelect
              labelId="inputSelectLabel-idType"
              id="inputSelect-idType"
              label={t('admin->>CandidateBlacklist.IdType')}
              name="IdType"
              control={control}
              menuItems={ID_TYPE_MENU_ITEMS}
              defaultValue="I"
              variant="filled"
              className={classes.halfWidthLeftItem}
              fullWidth
              isRequired
            />
          </Grid>
          <Grid xs={12} sm={6}>
            <TextFieldForm
                form={form}
              label={t('admin->>CandidateBlacklist.uinfinOrPassword')}
              name="uinfinOrPassport"
              type="text"
              error={!!errors.uinfinOrPassport}
              helperText={errors?.uinfinOrPassport?.message?.toString()}
              fullWidth
              isRequired
            />
          </Grid>
        </Grid>
        <ControlledDatePicker
            control={control  }
          label={t('admin->>CandidateBlacklist.DateOfBirth')}
          name="dateOfBirth"
          inputVariant="filled"
          value={dateOfBirth}
          onChange={(date) => {
            setDateOfBirth(date || '');
            setValue('dateOfBirth', date || '');
          }}
          error={!!errors.dateOfBirth}
          helperText={errors?.dateOfBirth?.message?.toString()}
          disableFuture
          className={classes.formElementContainer}
          maxDate={dayjs(yesterdayDate)}
          autoOk
          isRequired
        />
        <ControlledAutocomplete<DropDownItem, false, false, undefined>
          placeholder={t('admin->>CandidateBlacklist.SelectExamType')}
          label={t('admin->>CandidateBlacklist.ExamType')}
          name="examType"
          id="inputSelect-examType"
          options={BlacklistingExamType}
          control={control}
          error={!!errors.examType}
          helperText={errors?.examType?.message?.toString()}
          getOptionLabel={(option: DropDownItem) => option.children}
          transform={{
            input: (selectedOption, options) =>
              options.find((option) => option.value === selectedOption) ?? null,
            output: (selectedOption) => (selectedOption ? selectedOption.value : null),
          }}
          isRequired
        />
        <>
          <ErrorInfo className={classes.errMsg} label={submitError || ''} />
          <Grid container>
            <Button
              id="button-candidateBlacklist-cancel"
              variant="outlined"
              onClick={() => {
                history.push(`/${admin}/${candidateBlacklist.route}`);
              }}
              className={classes.actionButton}
            >
              {t('admin->>CandidateBlacklist.Cancel')}
            </Button>
            <ApiButton
              id="button-candidateBlacklist-addCandidate"
              status={apiMutation.status}
              type="submit"
              className={classes.actionButton}
            >
              {t('admin->>CandidateBlacklist.AddCandidate')}
            </ApiButton>
          </Grid>
        </>
      </form>
    </ContentTemplate>
  );
};

export default AddCandidateBlacklist;
